// Usage-rights duration bounds (days). Mirrors the create-campaign wizard's Zod
// rule — packages/ui can't import from an app, so the bounds are restated here.
export const USAGE_RIGHTS_MIN_DAYS = 30;
export const USAGE_RIGHTS_MAX_DAYS = 1095;

export function isUsageRightsDaysValid(days: number): boolean {
  return Number.isInteger(days) && days >= USAGE_RIGHTS_MIN_DAYS && days <= USAGE_RIGHTS_MAX_DAYS;
}

// A field that fails validation gets the design-system destructive border token,
// including while focused (the focus-visible variant out-specifies the Input's focus border).
export function invalidBorder(invalid: boolean): string {
  if (!invalid) return '';
  return 'border-border-destructive-default focus-visible:border-border-destructive-default';
}

// Validation message for an invalid duration, in the same wording the wizard uses.
export function getUsageRightsError(days: number): string {
  if (!Number.isFinite(days)) return 'Duration is required';
  if (!Number.isInteger(days)) return 'Enter a whole number of days';
  if (days < USAGE_RIGHTS_MIN_DAYS) return `Minimum ${USAGE_RIGHTS_MIN_DAYS} days`;
  return 'Maximum 3 years (1095 days)';
}
